module.exports = __webpack_public_path__ + "static/media/track-collapse.a2b736d4.svg";